import { Box, Text } from "@mantine/core";
import { RichTextEditor } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text as TiptapText } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";
import { HardBreak } from "@tiptap/extension-hard-break";
import { useEffect } from "react";

function ExpandedRow({
  description,
  descriptionRich,
  descTitleSize = "sm",
  padding = "md",
  descriptionText = "Description",
  noDescriptionText = "No description provided for this session.",
}) {
  let parsedRichContent = descriptionRich;
  if (typeof descriptionRich === "string") {
    try {
      parsedRichContent = JSON.parse(descriptionRich);
    } catch (e) {
      parsedRichContent = null;
    }
  }
  const hasRichText =
    parsedRichContent && typeof parsedRichContent === "object";
  const editor = useEditor({
    extensions: [
      Document,
      Paragraph,
      TiptapText,
      Bold,
      Italic,
      Underline,
      HardBreak,
    ],
    content: hasRichText ? parsedRichContent : null,
    editable: false,
  });
  useEffect(() => {
    if (
      editor &&
      hasRichText &&
      JSON.stringify(editor.getJSON()) !== JSON.stringify(parsedRichContent)
    ) {
      editor.commands.setContent(parsedRichContent);
    }
  }, [editor, parsedRichContent, hasRichText]);

  return (
    <Box
      p={padding}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Text size={descTitleSize} mb="xs" style={{ fontWeight: "bold" }}>
        {descriptionText}
      </Text>
      {hasRichText ? (
        <RichTextEditor editor={editor} style={{ border: "none", padding: 0 }}>
          <RichTextEditor.Content />
        </RichTextEditor>
      ) : (
        <Text
          size="sm"
          c={!description ? "red" : "black"}
          style={{ whiteSpace: "pre-wrap" }}
        >
          {description || noDescriptionText}
        </Text>
      )}
    </Box>
  );
}

export default ExpandedRow;
